import { useEffect } from 'react';
export default function useGameViewportFit(rootRef) {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    let frame;
    const measure = () => {
      if (window.innerWidth >= 900) { root.style.removeProperty('--game-board-side'); return; }
      const main = root.querySelector(':scope > main'), header = root.querySelector(':scope > header'), board = root.querySelector('.game-board');
      if (!main || !header || !board) return;
      const style = getComputedStyle(root);
      const padding = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
      const otherContent = main.scrollHeight - board.getBoundingClientRect().height;
      const available = root.clientHeight - padding - header.getBoundingClientRect().height - otherContent - 10;
      const side = Math.floor(Math.max(120, Math.min(400, main.clientWidth - 24, available)));
      if (root.style.getPropertyValue('--game-board-side') !== `${side}px`) root.style.setProperty('--game-board-side', `${side}px`);
    };
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(measure); };
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(schedule);
    [root, root.querySelector(':scope > main'), root.querySelector(':scope > header'), root.querySelector('aside')].filter(Boolean).forEach(node => observer?.observe(node));
    window.addEventListener('resize', schedule);
    window.visualViewport?.addEventListener('resize', schedule);
    schedule();
    return () => { cancelAnimationFrame(frame); observer?.disconnect(); window.removeEventListener('resize', schedule); window.visualViewport?.removeEventListener('resize', schedule); };
  }, [rootRef]);
}
